<template>
  <div>
    <h3>审核产品信息</h3>
    <div class="bill-box" v-for="(item, index) in selectData" :key="index">
      <div class="bill-label">寻样单信息:</div>
      <OutsideSample :showLog="false" :id="item.id" @return-sample-data="returnSampleData($event, index)" />
      <div class="bill-label" style="margin-top: 10px;">审核意见:</div>
      <el-form
        ref="confirmInfoForm"
        style="width: 100%"
        :model="item"
        label-width="100px"
        size="mini"
        :rules="rules"
      >
        <el-form-item label="审核结果" prop="checkStatus">
          <DictSelect
            type="cml_sample_checkstatus"
            :value="item.checkStatus"
            @change-emit="checkStatusChange($event, index)"
          />
        </el-form-item>
        <div v-if="item.checkStatus === 'PASS'">
          <el-form-item label="要求到样时间" prop="askArrivalTimeVerify">
            <el-date-picker
              v-model="item.askArrivalTimeVerify"
              type="datetime"
              placeholder="选择时间"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="expireTimeOption"
            />
          </el-form-item>
          <el-form-item label="给供应商留言" prop="forSupplierRemark">
            <el-input
              style="width: 300px"
              type="textarea"
              placeholder="请输入内容"
              v-model="item.forSupplierRemark"
              maxlength="100"
              size="mini"
              show-word-limit
            />
          </el-form-item>
          <el-form-item label="供应商" prop="supplierList" class="supplier-list">
            <p v-for="(item, index) in item.supplierList" :key="index" class="">
              {{ item.name }}
              <i class="el-icon-close" @click.stop="deleteBtn(index)" />
            </p>
            <el-button
              icon="el-icon-plus"
              @click="openSupplier(index)"
              >添加供应商</el-button
            >
          </el-form-item>
        </div>
        <div v-if="item.checkStatus === 'NO_PASS'">
          <el-form-item label="理由" prop="checkRemark">
            <el-input
              style="width: 300px"
              type="textarea"
              placeholder="请输入内容"
              v-model="item.checkRemark"
              maxlength="30"
              size="mini"
              show-word-limit
            />
          </el-form-item>
        </div>
      </el-form>
    </div>

    <div style="text-align: center; margin-bottom: 20px;">
      <el-button type="primary" @click="save" :loading="saveLoading">提交</el-button>
      <el-button @click="cancelBtn">取消</el-button>
    </div>
    <!-- 供应商 -->
    <AddProduct
      ref="addProduct"
      :title="'supplier'"
      :type="formData.productType"
      :leftTitle="titleList"
      :rightTitle="titleList"
      @close="addSupplier"
    />
  </div>
</template>
<script>
import DictSelect from '@/components/DictSelect';
import AddProduct from '@/components/AddProductDialog';
import OutsideSample from '@/components/OutsideSample';
import { unionBy } from 'lodash';
import dayjs from 'dayjs';
export default {
  components: { DictSelect, AddProduct, OutsideSample },
  props: {
    removeTab: {
      type: Function,
      default: null,
    },
  },
  data: () => ({
    selectData: [],
    formData: {
      checkStatus: '',
      askArrivalTime: '',
      forSupplierRemark: '',
      supplierList: [],
      checkRemark: '',
    },
    saveLoading: false,
    rules: {
      checkStatus: [
        { required: true, message: '请选择审核结果', trigger: 'change' },
      ],
      checkRemark: [{ required: true, message: '请输入理由', trigger: 'blur' }],
      supplierList: [
        { required: true, message: '请选择供应商', trigger: 'change' },
      ],
    },
    expireTimeOption: {
      disabledDate: (time) => {
        return time.getTime() < Date.now() - 8.64e7;
      },
    },
    dialogVisible: false,
    titleList: [
      { prop: 'name', label: '供应商名称' },
      { prop: 'categoryName', label: '供应商大类' },
    ],
    detailData: {},
    $index: null
  }),
  mounted() {},
  methods: {
    getDetail(arr) {
      this.selectData = arr;
      this.$nextTick(() => {
        this.clearConfirmInfoForm();
      });
    },
    checkStatusChange(val, index) {
      // 清空审核数据
      const item = this.selectData[index];
      this.$set(item, 'checkStatus', val);
      this.$set(item, 'askArrivalTimeVerify', '');
      this.$set(item, 'forSupplierRemark', '');
      this.$set(item, 'checkRemark', '');
      this.$set(item, 'supplierList', []);
      this.$refs.confirmInfoForm[index].clearValidate();
      // 设置默认值
      if (val === 'PASS') {
        this.$nextTick(() => {
          const { askArrivalTime, specialRemark } = item.detailData;
          this.$set(item, 'askArrivalTimeVerify', askArrivalTime);
          this.$set(item, 'forSupplierRemark', specialRemark);
        });
      }
    },
    returnSampleData(obj, index) {
      const item = this.selectData[index];
      this.$set(item, 'detailData', obj);
    },
    save() {
      // form校验
      if (!this.checkFormValid()) {
        return;
      }
      // 校验要求到样时间
      let errArr = this.selectData.filter(item => dayjs(dayjs().format('YYYY-MM-DD HH:mm:ss')).diff(dayjs(item.askArrivalTimeVerify)) > 0);
      if(errArr.length > 0) {
        this.$message.error(`产品名称【${errArr[0].productName}】的要求到样时间不能早于当前时间`);
        return;
      }
      const params = [ ...this.selectData ].map(item => {
        item.urlList = item.detailData.urlList;
        item.askArrivalTime = item.askArrivalTimeVerify;
        item.supplierCodeList = item.supplierList.map(item => item.code);
        return item;
      });
     
      this.saveLoading = true;
      this.$http.outsideSampleManage
        .batchAddCheckInfo(params)
        .then(() => {
          this.$message.success('操作成功');
          this.removeTab('detail');
        })
        .catch(err => {
          this.$message.error(err.msg);
        })
        .finally(() => {
          this.saveLoading = false;
        });
    },
    openSupplier(index) {
      this.$index = index;
      this.$refs.addProduct.getList();
    },
    // 添加供应商
    addSupplier({data}) {
      const item = this.selectData[this.$index];
      this.$set(item, 'supplierList', unionBy(item.supplierList, data, 'name'));
      item.supplierList.length > 0 && this.$refs.confirmInfoForm[this.$index].clearValidate('supplierList');
    },
    deleteBtn(index) {
      this.selectData[this.$index].supplierList.splice(index, 1);
    },
    // 清空form表单
    clearConfirmInfoForm() {
      this.$nextTick(() => {
        this.$refs.confirmInfoForm.map(el => {
          el.resetFields();
        });
      });
    },
    checkFormValid() {
      let formValid = []; // 正确数据
      this.$refs.confirmInfoForm.map(item => {
        item.validate(valid => {
          formValid.push(valid)
        });
      });
      return formValid.every(Boolean);
    },
    cancelBtn() {
      this.removeTab('detail');
    }
  },
};
</script>
<style lang="less" scoped>
h3 {
  text-align: center;
  margin-bottom: 10px;
}
.bill-box {
  padding: 0 20px;
  margin-bottom: 30px;
  border-bottom: 1px dashed #ccc;
  form {
    margin-left: 125px;
  }
}
.bill-label {
  width: 130px;
  font-weight: bold;
}
.supplier-list {
  p {
    position: relative;
    width: 300px;
    padding-right: 20px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    i {
      position: absolute;
      right: 0;
      top: 8px;
      &:hover {
        cursor: pointer;
        color: #f00;
      }
    }
  }
}
</style>